import { useContext } from 'react'

import { OrderDraftItemMutationStatusContext } from './OrderDraftItemMutationStatusContext'

export const useOrderDraftItemMutationStatusContext = () => {
  const context = useContext(OrderDraftItemMutationStatusContext)

  if (!context) {
    throw new Error(
      'useOrderDraftItemMutationStatusContext must be used within an OrderDraftItemMutationStatusContextProvider'
    )
  }

  return context
}
